import { s } from "@fullcalendar/core/internal-common";
import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

let initialData: any = {
    companyDetails: {},
    contactDetails: {},
    staffDetails: [],
    selectedStaff: null,
    isUpdatedStaff: false,
    facilitiesDetails: [],
    selectedFacility: null,
    isUpdatedFacility: false,
    teamDetails: [],
    selectedTeam: null,
    isUpdatedTeam: false,
    profitAndLossDetails: [],
    isUpdatedProfitAndLoss: false,
    supportFundDetails: [],
    isUpdatedSupportFund: false,
    playerDetails: [],
    selectedPlayer: null,
    isUpdatedPlayer: false
};


export const dataCaptures = createSlice({
    name: 'dataCaptures',
    initialState: initialData,
    reducers: {
        setCompanyDetails: (state: any, action: any) => {
            state.companyDetails =  action.payload;
            return state;
        },
        setContactDetails: (state: any, action: any) => {
            state.contactDetails =  action.payload;
            return state;
        },
        setStaffDetails: (state: any, action: any) => {
            state.staffDetails =  action.payload;
            return state;
        },
        setSelectedStaff: (state: any, action: any) => {
            state.selectedStaff =  action.payload;
            return state;
        },
        resetSelectedStaff: (state: any) => {
            state.selectedStaff =  initialData.selectedStaff;
            return state;
        },
        setFacilitiesDetails: (state: any, action: any) => {
            state.facilitiesDetails =  action.payload;
            return state;
        },
        setSelectedFacility: (state: any, action: any) => {
            state.selectedFacility =  action.payload;
            return state;
        },
        resetSelectedFacility: (state: any) => {
            state.selectedFacility =  initialData.selectedFacility;
            return state;
        },
        setTeamDetails: (state: any, action: any) => {
            state.teamDetails =  action.payload;
            return state;
        },
        setSelectedTeam: (state: any, action: any) => {
            state.selectedTeam =  action.payload;
            return state;
        },
        resetSelectedTeam: (state: any) => {
            state.selectedTeam =  initialData.selectedTeam;
            return state;
        },
        setProfitAndLossDetails: (state: any, action: any) => {
            state.profitAndLossDetails =  action.payload;
            return state;
        },
        setSupportFundDetails: (state: any, action: any) => {
            state.supportFundDetails =  action.payload;
            return state;
        },
        restProfitAndLossDetails: (state: any) => {
            state.profitAndLossDetails =  initialData.profitAndLossDetails;
            return state;
        },
        restSupportFundDetails: (state: any) => {
            state.supportFundDetails =  initialData.supportFundDetails;
            return state;
        },
        setPlayerDetails: (state: any, action: any) => {
            state.playerDetails =  action.payload;
            return state;
        },
        setSelectedPlayer: (state: any, action: any) => {
            state.selectedPlayer =  action.payload;
            return state;
        },
        resetSelectedPlayer: (state: any) => {
            state.selectedPlayer =  initialData.selectedPlayer;
            return state;
        },
        setIsUpdatedStaff: (state: any, action: any) => {
            state.isUpdatedStaff =  action.payload;
            return state;
        },
        setIsUpdatedFacility: (state: any, action: any) => {
            state.isUpdatedFacility =  action.payload;
            return state;
        },
        setIsUpdatedTeam: (state: any, action: any) => {
            state.isUpdatedTeam =  action.payload;
            return state;
        },
        setIsUpdatedPlayer: (state: any, action: any) => {
            state.isUpdatedPlayer =  action.payload;
            return state;
        },
        setIsUpdatedProfitAndLoss: (state: any, action: any) => {
            state.isUpdatedProfitAndLoss =  action.payload;
        },
        setIsUpdatedSupportFund: (state: any, action: any) => {
            state.isUpdatedSupportFund =  action.payload;
        },
        resetDataCaptures: (state: any) => {
            state =  initialData;
            return state;
        },
    }
});

export const {
    setCompanyDetails,
    setContactDetails,
    setStaffDetails,
    setFacilitiesDetails,
    setTeamDetails,
    setProfitAndLossDetails,
    setSupportFundDetails,
    restProfitAndLossDetails,
    restSupportFundDetails,
    setPlayerDetails,
    setSelectedStaff,
    resetSelectedStaff,
    setSelectedFacility,
    resetSelectedFacility,
    setSelectedTeam,
    resetSelectedTeam,
    setSelectedPlayer,
    resetSelectedPlayer,
    setIsUpdatedStaff,
    setIsUpdatedFacility,
    setIsUpdatedTeam,
    setIsUpdatedPlayer,
    setIsUpdatedProfitAndLoss,
    setIsUpdatedSupportFund,
    resetDataCaptures
} = dataCaptures.actions;
export default dataCaptures.reducer;